"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiPaper = getMuiPaper;
function getMuiPaper(palette) {
  return {
    defaultProps: {},
    styleOverrides: {
      root: {
        '.MuiAccordion-root': {
          boxShadow: 'none',
          padding: 0
        },
        '.MuiList-root': {
          '& .MuiMenuItem-root': {
            '&.Mui-selected': {
              '&:hover': {
                backgroundColor: palette.primary[50]
              },
              backgroundColor: palette.primary[50]
            },
            '&:hover': {
              backgroundColor: palette.grey[50]
            }
          },
          padding: '16px 8px'
        }
      }
    }
  };
}